import { Routes } from '@angular/router';

//Route for content layout without sidebar, navbar and footer for pages like Login, Registration etc...

export const WEBSITE_ROUTES: Routes = [
   {
        path: 'website',
        loadChildren: () => import('./../../website/website.module').then(m => m.WebsiteModule)
    }
];
